'use client'

import { getCookie } from 'cookies-next/client'
import { useAtomValue } from 'jotai'
import { useMount } from 'react-use'
import { userAtom } from '../stores/user/atoms'

/** Open Intercom widget with a message. */
export async function showIntercomWidget() {
  const { show } = await import('@intercom/messenger-js-sdk')
  show()
}

export default function IntercomWidget() {
  const user = useAtomValue(userAtom)

  useMount(async () => {
    const Intercom = (await import('@intercom/messenger-js-sdk')).default

    if (user.id !== 'guest') {
      Intercom({
        app_id: 'f6mfo1gs',
        user_id: user.id,
      })
    } else {
      const sessionId = await getCookie('session-id')

      Intercom({
        app_id: 'f6mfo1gs',
        user_id: sessionId,
      })
    }
  })

  return null
}
